import moment from 'moment'

export default function () {
  return this.test('datetime', 'Esse campo deve ser uma data válida', function (value) {
    return typeof value === 'string'
      ? moment(value, 'DD/MM/YYYY HH:mm', true).isValid()
      : true
  })
}
